import { render, staticRenderFns } from "./PhotosSelector.vue?vue&type=template&id=f13baeb8&scoped=true&"
import script from "./PhotosSelector.vue?vue&type=script&lang=js&"
export * from "./PhotosSelector.vue?vue&type=script&lang=js&"
import style0 from "./PhotosSelector.vue?vue&type=style&index=0&id=f13baeb8&lang=scss&scoped=true&"
import style1 from "./PhotosSelector.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13baeb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCarousel,VCarouselItem,VDialog,VIcon})
